import React, { useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";


export default function PrintOnDemand() {

    return (
        <>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Print On Demand</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Print On Demand</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/applique1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Texture. Depth. Creative Impact.</span>
                                <h3 className="case-study-title">Print On Demand Made Simple & Scalable</h3>
                                <p className="case-study-description">
                                    Turn your ideas into real products without the hassle of inventory or bulk production. Our print on demand service allows you to create custom apparel, accessories, and merchandise that are produced only when an order is placed. This flexible model helps businesses, brands, and creators launch products quickly while minimizing upfront costs and risks.
                                </p>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we combine expert digitizing, vector art, and production capabilities to ensure every product meets high-quality standards. From design preparation to final output, we handle the entire process so you can focus on growing your brand while we take care of printing, stitching, and fulfillment.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Structured for Seamless Fabric Application</span>
                                <h3 className="case-study-title">Custom Products Designed for Your Brand</h3>
                                <p className="case-study-description">
                                    With our print on demand solutions, you can offer a wide range of customized products including t-shirts, hoodies, caps, patches, and more. Each item is crafted using your unique designs, ensuring consistency in branding and professional results across every order—whether it’s a single piece or a growing product line.
                                </p>
                                <p className="case-study-description">
                                    Our streamlined workflow ensures fast turnaround times and reliable quality with every order. By integrating our embroidery digitizing and vector art expertise into the process, we deliver precise, production-ready designs that stand out. Whether you’re starting a new brand or expanding your existing business, we provide the tools and support you need to succeed.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/applique2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
